export const pagesDevDocumentsEn = {
  add: {
    bodyHint: 'Write in Markdown source. It is rendered after saving.',
    documentTitle: 'Add Development Document',
    errors: {
      invalidUrl: 'Invalid URL format',
      required: 'Required'
    },
    fields: {
      body: 'Body',
      externalFormat: 'Format Label',
      externalUrl: 'External URL',
      kind: 'Kind',
      product: 'Product',
      summary: 'Summary',
      tags: 'Tags',
      title: 'Title'
    },
    placeholders: {
      body: '# Heading\n\nWrite the body in Markdown.',
      externalFormat: 'xlsx / Google Sheets / Figma',
      externalUrl: 'https://',
      kind: 'Select a kind',
      product: 'Select a product',
      summary: 'One or two lines shown in the list',
      tags: 'e.g. architecture',
      title: 'Document title'
    },
    progressbar: {
      filled: 'filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required only',
      progressCircle: 'Progress circle',
      total: 'All Items'
    },
    step1: {
      nextButton: 'Next'
    },
    step2: {
      nextButton: 'Next',
      previousButton: 'Back'
    },
    step3: {
      previousButton: 'Back'
    },
    stepper: {
      basic: 'Basic Information',
      body: 'Body',
      reference: 'Reference Link & Tags',
      title: 'Sections'
    },
    submitButton: 'Create',
    toast: {
      success: 'The development document has been created.'
    }
  },
  detail: {
    actions: {
      openExternal: 'Open externally'
    },
    attachments: {
      actions: {
        cancel: 'Cancel',
        delete: 'Delete',
        download: 'Download'
      },
      columns: {
        createdAt: 'Uploaded At',
        createdBy: 'Uploaded By',
        fileName: 'File Name',
        fileSize: 'Size'
      },
      delete: {
        deleting: 'Deleting...',
        description: 'Are you sure you want to delete "{{fileName}}"?',
        submit: 'Delete',
        success: 'The attachment has been deleted.',
        title: 'Delete Attachment'
      },
      noResults: 'No attachments.',
      upload: {
        description: 'Select files to attach to this document. You can select multiple files.',
        error: {
          fileSizeExceeded: 'File size ({{actualSize}}MB) exceeds the maximum allowed size of {{maxSize}}MB.',
          invalidFileType: 'File type "{{mimeType}}" is not supported. Only JPEG, PNG, GIF, WebP, PDF, and CSV are allowed.'
        },
        helpText: 'JPEG / PNG / GIF / WebP / PDF / CSV, up to {{maxSize}}MB per file',
        submit: 'Upload',
        success: 'Uploaded {{total}} file(s).',
        title: 'Upload Attachments',
        uploading: 'Uploading...',
        validationError: 'File validation failed.'
      },
      uploadButton: 'Add File'
    },
    body: {
      empty: 'This document has no body yet.',
      linkHasNoBody: 'This document is owned by an external service, so no body is stored here.',
      preamble: 'Preamble'
    },
    breadcrumb: {
      devDocuments: 'Development Documents',
      home: 'Home'
    },
    fields: {
      code: 'Code',
      createdAt: 'Created At',
      createdBy: 'Created By',
      externalFormat: 'Format Label',
      externalUrl: 'External URL',
      kind: 'Kind',
      product: 'Product',
      status: 'Status',
      summary: 'Summary',
      tags: 'Tags',
      title: 'Title',
      updatedAt: 'Updated At'
    },
    options: {
      devDocumentKind: {
        ADR: 'ADR',
        DESIGN: 'Design',
        DIAGRAM: 'Diagram',
        INVESTIGATION: 'Investigation',
        MEETING_NOTE: 'Meeting Note',
        OTHER: 'Other',
        REQUIREMENT: 'Requirement',
        RULE: 'Rule',
        RUNBOOK: 'Runbook',
        SKILL: 'Skill',
        SPREADSHEET: 'Spreadsheet',
        WORK_LOG: 'Work Log'
      },
      devDocumentStatus: {
        ACTIVE: 'Active',
        ARCHIVED: 'Archive',
        DEPRECATED: 'Deprecated',
        DRAFT: 'Draft',
        SUPERSEDED: 'Superseded'
      }
    },
    pageTitle: 'Development Document Detail',
    tabs: {
      attachments: 'Attachments',
      body: 'Body',
      overview: 'Overview',
      tickets: 'Related Tickets'
    },
    tickets: {
      columns: {
        code: 'Code',
        kind: 'Kind',
        priority: 'Priority',
        status: 'Status',
        title: 'Title'
      },
      noResults: 'No related development tickets.'
    },
    topSections: {
      basicInfo: 'Basic Information',
      body: 'Body',
      classification: 'Classification',
      externalLink: 'Reference Link'
    }
  },
  list: {
    addDocument: 'Add Document',
    columns: {
      code: 'Code',
      kind: 'Kind',
      product: 'Product',
      source: 'Link',
      status: 'Status',
      title: 'Title',
      updatedAt: 'Updated At'
    },
    filterPlaceholder: 'Search by title, code or summary',
    filters: {
      kind: 'Kind',
      status: 'Status'
    },
    noResults: 'No development documents matched the current filter.',
    pageTitle: 'Development Documents',
    tabLabel: 'Development Document List',
    tabs: {
      active: 'Active',
      all: 'All',
      archived: 'Archive',
      deprecated: 'Deprecated',
      draft: 'Draft',
      superseded: 'Superseded'
    }
  }
};